export default {
    url: '/meta',
    template: '<ui-view></ui-view>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/settings/meta/index.js